import { useMemo } from "react";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";
import { useTheme } from "@fluentui/react/lib/Theme";

const classNames = {
  roles: `CompanyActionsRoles`,
  open: `CompanyActionsOpen`
};

export function useCompanyActionsStyles() {
  const { semanticColors } = useTheme();
  return useMemo(
    () => mergeStyleSets({
      roles: [
        classNames.roles,
        {
          width: `calc(100% - 74px)`
        }
      ],
      open: [
        classNames.open,
        {
          color: semanticColors.link,
          width: `32px`,
          height: `32px`,
          "& i": {
            fontSize: `19px`,
            lineHeight: `19px`,
            height: `24px`
          }
        }
      ]
    }),
    [semanticColors]
  );
}
